export default "__VITE_ASSET__CKA9LXb5__"